import React, {
    useEffect,
    useState
} from 'react';


import {
    useNavigate,
    useParams
} from 'react-router-dom';


import {
    useDispatch,
    useSelector
} from 'react-redux';


import Swal from 'sweetalert2';


import {
    crearUsuarioPacienteAction
} from '../../actions/crearPacienteActions';


import {
    cargarDatosPacienteNoRegistradoAction
} from '../../actions/invitarPacienteActions';


import {

    PaginaInvitacion,
    ContenedorInvitacion,

    EncabezadoInvitacion,
    MarcaInvitacion,
    TituloInvitacion,
    SubtituloInvitacion,

    TarjetaInvitacion,

    SeccionInvitacion,
    TituloSeccionInvitacion,
    TextoSeccionInvitacion,

    SeparadorInvitacion,

    GridInvitacion,

    CampoInvitacion,
    LabelInvitacion,
    InputInvitacion,
    ErrorCampoInvitacion,

    EmailPacienteInvitacion,

    ContenedorPassword,
    BotonMostrarPassword,
    AyudaPassword,

    AvisoTutorExistente,

    AvisoInvitacion,

    AccionesInvitacion,
    BotonCrearPaciente,

    EstadoInvitacion

} from '../Css/StyledInvitacionPaciente';


/*
========================================
FORMULARIO INICIAL
========================================
*/

const FORMULARIO_INICIAL = {

    nombre:
        '',

    apellido:
        '',

    fecha_nacimiento:
        '',


    nombre_1:
        '',

    apellido_1:
        '',

    email_1:
        '',

    email_confirmacion_1:
        '',


    nombre_2:
        '',

    apellido_2:
        '',

    email_2:
        '',

    email_confirmacion_2:
        '',


    password:
        '',

    password_confirmacion:
        ''

};


/*
========================================
INVITACIÓN PACIENTE
========================================
*/

const InvitacionPaciente = () => {

    const dispatch =
        useDispatch();


    const navigate =
        useNavigate();


    const {
        token
    } =
        useParams();


    /*
    ========================================
    PERFIL CARGADO DESDE EL TOKEN
    ========================================
    */

    const perfil =
        useSelector(
            state =>
                state.usuario.perfil
        );


    /*
    ========================================
    ESTADOS
    ========================================
    */

    const [
        formulario,
        setFormulario
    ] = useState(
        FORMULARIO_INICIAL
    );


    const [
        errores,
        setErrores
    ] = useState({});


    const [
        cargando,
        setCargando
    ] = useState(true);


    const [
        errorCarga,
        setErrorCarga
    ] = useState('');


    const [
        enviando,
        setEnviando
    ] = useState(false);


    const [
        errorGeneral,
        setErrorGeneral
    ] = useState('');


    const [
        mostrarPassword,
        setMostrarPassword
    ] = useState(false);


    /*
    ========================================
    DATOS DEL PERFIL
    ========================================
    */

    const emailPaciente =
        perfil?.email ||
        '';


    const tutorUnoExiste =
        perfil?.tutorUnoExiste ||
        '';


    const tutorDosExiste =
        perfil?.tutorDosExiste ||
        '';


    /*
    ========================================
    CAMBIAR CAMPO
    ========================================
    */

    const cambiarCampo =
        event => {

            const {
                name,
                value
            } =
                event.target;


            setFormulario(
                anterior => ({

                    ...anterior,

                    [name]:
                        value

                })
            );


            /*
            Al volver a escribir retiramos el
            error visual del campo.
            */

            setErrores(
                anterior => {

                    if (
                        !anterior[
                            name
                        ]
                    ) {

                        return anterior;

                    }


                    const copia = {
                        ...anterior
                    };


                    delete copia[
                        name
                    ];


                    return copia;

                }
            );


            setErrorGeneral(
                ''
            );

        };


    /*
    ========================================
    CARGAR DATOS
    ========================================
    */

    useEffect(
        () => {

            const cargar =
                async () => {

                    setCargando(
                        true
                    );


                    setErrorCarga(
                        ''
                    );


                    const respuesta =
                        await dispatch(
                            cargarDatosPacienteNoRegistradoAction({

                                payload: {

                                    token

                                }

                            })
                        );


                    setCargando(
                        false
                    );


                    if (
                        !respuesta?.ok
                    ) {

                        setErrorCarga(

                            respuesta
                                ?.error
                                ?.msg ||

                            'La invitación no es válida'

                        );

                    }

                };


            cargar();


            // eslint-disable-next-line react-hooks/exhaustive-deps
        },
        [
            token
        ]
    );


    /*
    ========================================
    COPIAR DATOS AL FORMULARIO
    ========================================
    */

    useEffect(
        () => {

            if (
                !perfil?.nombre
            ) {

                return;

            }


            setFormulario({

                nombre:
                    perfil.nombre ||
                    '',

                apellido:
                    perfil.apellido ||
                    '',

                fecha_nacimiento:
                    perfil.fecha_nacimiento ||
                    '',


                nombre_1:
                    perfil.nombre_1 ||
                    '',

                apellido_1:
                    perfil.apellido_1 ||
                    '',

                email_1:
                    perfil.email_1 ||
                    '',

                /*
                No completamos automáticamente
                la confirmación.

                Queremos que la familia vuelva
                a escribir el email y confirme
                que es correcto.
                */

                email_confirmacion_1:
                    '',


                nombre_2:
                    perfil.nombre_2 ||
                    '',

                apellido_2:
                    perfil.apellido_2 ||
                    '',

                email_2:
                    perfil.email_2 ||
                    '',

                email_confirmacion_2:
                    '',


                password:
                    '',

                password_confirmacion:
                    ''

            });

        },
        [
            perfil
        ]
    );


    /*
    ========================================
    VALIDAR
    ========================================
    */

    const validarFormulario =
        () => {

            const nuevosErrores =
                {};


            /*
            ====================================
            PACIENTE
            ====================================
            */

            if (
                !formulario.nombre.trim()
            ) {

                nuevosErrores.nombre =
                    'Ingresá el nombre';

            }


            if (
                !formulario.apellido.trim()
            ) {

                nuevosErrores.apellido =
                    'Ingresá el apellido';

            }


            if (
                !formulario.fecha_nacimiento
            ) {

                nuevosErrores.fecha_nacimiento =
                    'Ingresá la fecha de nacimiento';

            }


            /*
            ====================================
            TUTOR 1
            ====================================
            */

            if (
                !formulario.nombre_1.trim()
            ) {

                nuevosErrores.nombre_1 =
                    'Ingresá el nombre del Tutor 1';

            }


            if (
                !formulario.apellido_1.trim()
            ) {

                nuevosErrores.apellido_1 =
                    'Ingresá el apellido del Tutor 1';

            }


            if (
                !formulario.email_1.trim()
            ) {

                nuevosErrores.email_1 =
                    'Ingresá el email del Tutor 1';

            }


            if (
                !formulario.email_confirmacion_1.trim()
            ) {

                nuevosErrores.email_confirmacion_1 =
                    'Confirmá el email del Tutor 1';

            }


            if (
                formulario.email_1
                    .trim()
                    .toLowerCase() !==
                formulario.email_confirmacion_1
                    .trim()
                    .toLowerCase()
            ) {

                nuevosErrores.email_confirmacion_1 =
                    'Los emails del Tutor 1 no coinciden';

            }


            /*
            ====================================
            TUTOR 2 OPCIONAL
            ====================================

            Si se completa cualquiera de sus
            datos, entonces exigimos completar
            toda la identificación del Tutor 2.
            */

            const tutor2Comenzado =

                Boolean(
                    formulario.nombre_2.trim()
                ) ||

                Boolean(
                    formulario.apellido_2.trim()
                ) ||

                Boolean(
                    formulario.email_2.trim()
                ) ||

                Boolean(
                    formulario.email_confirmacion_2.trim()
                );


            if (
                tutor2Comenzado
            ) {

                if (
                    !formulario.nombre_2.trim()
                ) {

                    nuevosErrores.nombre_2 =
                        'Ingresá el nombre del Tutor 2';

                }


                if (
                    !formulario.apellido_2.trim()
                ) {

                    nuevosErrores.apellido_2 =
                        'Ingresá el apellido del Tutor 2';

                }


                if (
                    !formulario.email_2.trim()
                ) {

                    nuevosErrores.email_2 =
                        'Ingresá el email del Tutor 2';

                }


                if (
                    !formulario.email_confirmacion_2.trim()
                ) {

                    nuevosErrores.email_confirmacion_2 =
                        'Confirmá el email del Tutor 2';

                }


                if (
                    formulario.email_2
                        .trim()
                        .toLowerCase() !==
                    formulario.email_confirmacion_2
                        .trim()
                        .toLowerCase()
                ) {

                    nuevosErrores.email_confirmacion_2 =
                        'Los emails del Tutor 2 no coinciden';

                }

            }


            /*
            ====================================
            EMAILS ÚNICOS
            ====================================
            */

            const emailPacienteNormalizado =
                emailPaciente
                    .trim()
                    .toLowerCase();


            const emailTutor1Normalizado =
                formulario.email_1
                    .trim()
                    .toLowerCase();


            const emailTutor2Normalizado =
                formulario.email_2
                    .trim()
                    .toLowerCase();


            if (
                emailPacienteNormalizado &&
                emailPacienteNormalizado ===
                emailTutor1Normalizado
            ) {

                nuevosErrores.email_1 =
                    'El email del Tutor 1 no puede ser igual al del paciente';

            }


            if (
                emailTutor2Normalizado &&
                emailPacienteNormalizado ===
                emailTutor2Normalizado
            ) {

                nuevosErrores.email_2 =
                    'El email del Tutor 2 no puede ser igual al del paciente';

            }


            if (
                emailTutor2Normalizado &&
                emailTutor1Normalizado ===
                emailTutor2Normalizado
            ) {

                nuevosErrores.email_2 =
                    'Los tutores deben utilizar emails diferentes';

            }


            /*
            ====================================
            PASSWORD
            ====================================
            */

            if (
                !formulario.password
            ) {

                nuevosErrores.password =
                    'Ingresá una contraseña';

            } else {

                if (
                    formulario.password.length <
                    8
                ) {

                    nuevosErrores.password =
                        'Debe tener al menos 8 caracteres';

                } else if (
                    formulario.password.length >
                    15
                ) {

                    nuevosErrores.password =
                        'Debe tener como máximo 15 caracteres';

                } else if (
                    !/[a-z]/.test(
                        formulario.password
                    )
                ) {

                    nuevosErrores.password =
                        'Debe contener al menos una minúscula';

                } else if (
                    !/[A-Z]/.test(
                        formulario.password
                    )
                ) {

                    nuevosErrores.password =
                        'Debe contener al menos una mayúscula';

                } else if (
                    !/[0-9]/.test(
                        formulario.password
                    )
                ) {

                    nuevosErrores.password =
                        'Debe contener al menos un número';

                }

            }


            if (
                !formulario.password_confirmacion
            ) {

                nuevosErrores.password_confirmacion =
                    'Confirmá la contraseña';

            } else if (
                formulario.password !==
                formulario.password_confirmacion
            ) {

                nuevosErrores.password_confirmacion =
                    'Las contraseñas no coinciden';

            }


            setErrores(
                nuevosErrores
            );


            return (
                Object.keys(
                    nuevosErrores
                ).length ===
                0
            );

        };


    /*
    ========================================
    CREAR CUENTA
    ========================================
    */

    const enviarFormulario =
        async event => {

            event.preventDefault();


            if (
                enviando
            ) {

                return;

            }


            setErrorGeneral(
                ''
            );


            const valido =
                validarFormulario();


            if (
                !valido
            ) {

                setErrorGeneral(
                    'Revisá los campos marcados antes de continuar.'
                );


                return;

            }


            setEnviando(
                true
            );


            const respuesta =
                await dispatch(
                    crearUsuarioPacienteAction({

                        payload: {

                            token,

                            email:
                                emailPaciente,

                            nombre:
                                formulario
                                    .nombre
                                    .trim(),

                            apellido:
                                formulario
                                    .apellido
                                    .trim(),

                            fecha_nacimiento:
                                formulario
                                    .fecha_nacimiento,


                            nombre_1:
                                formulario
                                    .nombre_1
                                    .trim(),

                            apellido_1:
                                formulario
                                    .apellido_1
                                    .trim(),

                            email_1:
                                formulario
                                    .email_1
                                    .trim()
                                    .toLowerCase(),


                            nombre_2:
                                formulario
                                    .nombre_2
                                    .trim(),

                            apellido_2:
                                formulario
                                    .apellido_2
                                    .trim(),

                            email_2:
                                formulario
                                    .email_2
                                    .trim()
                                    .toLowerCase(),

                            password:
                                formulario.password

                        }

                    })
                );


            setEnviando(
                false
            );


            if (
                !respuesta?.ok
            ) {

                setErrorGeneral(

                    respuesta
                        ?.error
                        ?.msg ||

                    'No se pudo crear la cuenta'

                );


                return;

            }


            await Swal.fire({

                icon:
                    'success',

                title:
                    'Cuenta creada',

                text:
                    'La cuenta del paciente fue creada correctamente.',

                confirmButtonText:
                    'Ir a iniciar sesión',

                confirmButtonColor:
                    '#23AAAF'

            });


            navigate(
                '/login'
            );

        };


    /*
    ========================================
    CARGANDO
    ========================================
    */

    if (
        cargando
    ) {

        return (

            <PaginaInvitacion>

                <ContenedorInvitacion>

                    <EstadoInvitacion>

                        Estamos cargando los datos
                        de la invitación...

                    </EstadoInvitacion>

                </ContenedorInvitacion>

            </PaginaInvitacion>

        );

    }


    /*
    ========================================
    ERROR TOKEN / CARGA
    ========================================
    */

    if (
        errorCarga ||
        !emailPaciente
    ) {

        return (

            <PaginaInvitacion>

                <ContenedorInvitacion>

                    <EstadoInvitacion>

                        <strong>

                            No pudimos abrir esta invitación.

                        </strong>

                        <br />
                        <br />

                        {
                            errorCarga ||
                            'La invitación no contiene información válida.'
                        }

                        <br />
                        <br />

                        Solicitá al profesional que
                        envíe una nueva invitación.

                    </EstadoInvitacion>

                </ContenedorInvitacion>

            </PaginaInvitacion>

        );

    }


    /*
    ========================================
    RENDER
    ========================================
    */

    return (

        <PaginaInvitacion>


            <ContenedorInvitacion>


                <EncabezadoInvitacion>

                    <MarcaInvitacion>

                        MÉTODO YÖGEN

                    </MarcaInvitacion>


                    <TituloInvitacion>

                        Crear cuenta del paciente

                    </TituloInvitacion>


                    <SubtituloInvitacion>

                        Revisá los datos cargados por
                        el profesional, corregilos si
                        fuera necesario y creá una
                        contraseña para finalizar el
                        registro.

                    </SubtituloInvitacion>

                </EncabezadoInvitacion>


                {
                    errorGeneral && (

                        <AvisoInvitacion>

                            {errorGeneral}

                        </AvisoInvitacion>

                    )
                }


                <TarjetaInvitacion>


                    <form
                        onSubmit={
                            enviarFormulario
                        }
                    >


                        {/* =========================
                            PACIENTE
                        ========================== */}

                        <SeccionInvitacion>


                            <TituloSeccionInvitacion>

                                Datos del paciente

                            </TituloSeccionInvitacion>


                            <TextoSeccionInvitacion>

                                Confirmá que la información
                                sea correcta antes de crear
                                la cuenta.

                            </TextoSeccionInvitacion>


                            <EmailPacienteInvitacion>

                                Email del paciente:{' '}

                                <strong>

                                    {emailPaciente}

                                </strong>

                            </EmailPacienteInvitacion>


                            <GridInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Nombre <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="text"

                                        name="nombre"

                                        value={
                                            formulario.nombre
                                        }

                                        $error={
                                            Boolean(
                                                errores.nombre
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.nombre && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.nombre
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Apellido <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="text"

                                        name="apellido"

                                        value={
                                            formulario.apellido
                                        }

                                        $error={
                                            Boolean(
                                                errores.apellido
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.apellido && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.apellido
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Fecha de nacimiento <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="date"

                                        name="fecha_nacimiento"

                                        value={
                                            formulario.fecha_nacimiento
                                        }

                                        $error={
                                            Boolean(
                                                errores.fecha_nacimiento
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.fecha_nacimiento && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.fecha_nacimiento
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                            </GridInvitacion>


                        </SeccionInvitacion>


                        <SeparadorInvitacion />


                        {/* =========================
                            PASSWORD
                        ========================== */}

                        <SeccionInvitacion>


                            <TituloSeccionInvitacion>

                                Contraseña del paciente

                            </TituloSeccionInvitacion>


                            <TextoSeccionInvitacion>

                                Esta contraseña será utilizada
                                para ingresar al espacio del
                                paciente y realizar las
                                actividades asignadas.

                            </TextoSeccionInvitacion>


                            <GridInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Contraseña <strong>*</strong>

                                    </LabelInvitacion>


                                    <ContenedorPassword>

                                        <InputInvitacion

                                            type={
                                                mostrarPassword
                                                    ?
                                                    'text'
                                                    :
                                                    'password'
                                            }

                                            name="password"

                                            autoComplete="new-password"

                                            value={
                                                formulario.password
                                            }

                                            $error={
                                                Boolean(
                                                    errores.password
                                                )
                                            }

                                            disabled={
                                                enviando
                                            }

                                            onChange={
                                                cambiarCampo
                                            }

                                        />


                                        <BotonMostrarPassword

                                            type="button"

                                            onClick={
                                                () =>
                                                    setMostrarPassword(
                                                        valor =>
                                                            !valor
                                                    )
                                            }

                                        >

                                            {
                                                mostrarPassword
                                                    ?
                                                    'Ocultar'
                                                    :
                                                    'Ver'
                                            }

                                        </BotonMostrarPassword>


                                    </ContenedorPassword>


                                    {
                                        errores.password && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.password
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Confirmar contraseña <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type={
                                            mostrarPassword
                                                ?
                                                'text'
                                                :
                                                'password'
                                        }

                                        name="password_confirmacion"

                                        autoComplete="new-password"

                                        value={
                                            formulario.password_confirmacion
                                        }

                                        $error={
                                            Boolean(
                                                errores.password_confirmacion
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.password_confirmacion && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.password_confirmacion
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                            </GridInvitacion>


                            <AyudaPassword>

                                La contraseña debe tener entre
                                8 y 15 caracteres e incluir al
                                menos una mayúscula, una
                                minúscula y un número.

                            </AyudaPassword>


                        </SeccionInvitacion>


                        <SeparadorInvitacion />


                        {/* =========================
                            TUTOR 1
                        ========================== */}

                        <SeccionInvitacion>


                            <TituloSeccionInvitacion>

                                Tutor 1

                            </TituloSeccionInvitacion>


                            <TextoSeccionInvitacion>

                                Estos datos son obligatorios.

                            </TextoSeccionInvitacion>


                            {
                                tutorUnoExiste && (

                                    <AvisoTutorExistente>

                                        El email{' '}

                                        <strong>

                                            {tutorUnoExiste}

                                        </strong>

                                        {' '}ya corresponde a un
                                        tutor registrado en YÖGEN.

                                        Si pertenece a esta persona
                                        podés continuar normalmente.

                                    </AvisoTutorExistente>

                                )
                            }


                            <GridInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Nombre <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="text"

                                        name="nombre_1"

                                        value={
                                            formulario.nombre_1
                                        }

                                        $error={
                                            Boolean(
                                                errores.nombre_1
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.nombre_1 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.nombre_1
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Apellido <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="text"

                                        name="apellido_1"

                                        value={
                                            formulario.apellido_1
                                        }

                                        $error={
                                            Boolean(
                                                errores.apellido_1
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.apellido_1 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.apellido_1
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Email <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="email"

                                        name="email_1"

                                        value={
                                            formulario.email_1
                                        }

                                        $error={
                                            Boolean(
                                                errores.email_1
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.email_1 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.email_1
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>

                                        Confirmar email <strong>*</strong>

                                    </LabelInvitacion>


                                    <InputInvitacion

                                        type="email"

                                        name="email_confirmacion_1"

                                        value={
                                            formulario.email_confirmacion_1
                                        }

                                        $error={
                                            Boolean(
                                                errores.email_confirmacion_1
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />


                                    {
                                        errores.email_confirmacion_1 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.email_confirmacion_1
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                            </GridInvitacion>


                        </SeccionInvitacion>


                        <SeparadorInvitacion />


                        {/* =========================
                            TUTOR 2
                        ========================== */}

                        <SeccionInvitacion>


                            <TituloSeccionInvitacion>

                                Tutor 2

                            </TituloSeccionInvitacion>


                            <TextoSeccionInvitacion>

                                Esta sección es opcional.
                                Si completás un dato del
                                Tutor 2, deberás completar
                                también los demás.

                            </TextoSeccionInvitacion>


                            {
                                tutorDosExiste && (

                                    <AvisoTutorExistente>

                                        El email{' '}

                                        <strong>

                                            {tutorDosExiste}

                                        </strong>

                                        {' '}ya corresponde a un
                                        tutor registrado en YÖGEN.

                                        Si pertenece a esta persona
                                        podés continuar normalmente.

                                    </AvisoTutorExistente>

                                )
                            }


                            <GridInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>
                                        Nombre
                                    </LabelInvitacion>

                                    <InputInvitacion

                                        type="text"

                                        name="nombre_2"

                                        value={
                                            formulario.nombre_2
                                        }

                                        $error={
                                            Boolean(
                                                errores.nombre_2
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />

                                    {
                                        errores.nombre_2 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.nombre_2
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>
                                        Apellido
                                    </LabelInvitacion>

                                    <InputInvitacion

                                        type="text"

                                        name="apellido_2"

                                        value={
                                            formulario.apellido_2
                                        }

                                        $error={
                                            Boolean(
                                                errores.apellido_2
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />

                                    {
                                        errores.apellido_2 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.apellido_2
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>
                                        Email
                                    </LabelInvitacion>

                                    <InputInvitacion

                                        type="email"

                                        name="email_2"

                                        value={
                                            formulario.email_2
                                        }

                                        $error={
                                            Boolean(
                                                errores.email_2
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />

                                    {
                                        errores.email_2 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.email_2
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                                <CampoInvitacion>

                                    <LabelInvitacion>
                                        Confirmar email
                                    </LabelInvitacion>

                                    <InputInvitacion

                                        type="email"

                                        name="email_confirmacion_2"

                                        value={
                                            formulario.email_confirmacion_2
                                        }

                                        $error={
                                            Boolean(
                                                errores.email_confirmacion_2
                                            )
                                        }

                                        disabled={
                                            enviando
                                        }

                                        onChange={
                                            cambiarCampo
                                        }

                                    />

                                    {
                                        errores.email_confirmacion_2 && (

                                            <ErrorCampoInvitacion>

                                                {
                                                    errores.email_confirmacion_2
                                                }

                                            </ErrorCampoInvitacion>

                                        )
                                    }

                                </CampoInvitacion>


                            </GridInvitacion>


                        </SeccionInvitacion>


                        <AccionesInvitacion>

                            <BotonCrearPaciente

                                type="submit"

                                disabled={
                                    enviando
                                }

                            >

                                {
                                    enviando
                                        ?
                                        'Creando cuenta...'
                                        :
                                        'Crear cuenta'
                                }

                            </BotonCrearPaciente>

                        </AccionesInvitacion>


                    </form>


                </TarjetaInvitacion>


            </ContenedorInvitacion>


        </PaginaInvitacion>

    );

};


export default InvitacionPaciente;